import Courses from './../src/courses/index.js'
window.courses = new Courses()
